import { render, staticRenderFns } from "./RequiredColumnsOnImport.vue?vue&type=template&id=29165231&"
import script from "./RequiredColumnsOnImport.vue?vue&type=script&lang=js&"
export * from "./RequiredColumnsOnImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports